import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { countDays } from '@app/activo2/manage-vacations/manage-vacations.constants';
import { IProposal } from '@app/activo2/manage-vacations/manage-vacations.interface';
import { SeasonCalendar, VacationsSeason } from '@app/activo2/manage-vacations/manage-vacations.model';
import { AlertService } from '@app/services';
import { ErrorMsg } from '@app/services/error/error.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { TranslateService } from '@ngx-translate/core';
import { isEqual } from 'lodash';

/* eslint-disable @typescript-eslint/naming-convention */

@Component({
  selector: 'app-mot-calendar-step',
  templateUrl: '../../../../activo2/manage-vacations/components/calendar-step/calendar-step.component.html',
  styleUrls: ['../../../../activo2/manage-vacations/components/calendar-step/calendar-step.component.scss']
})
export class CalendarStepComponent implements OnChanges {
  @Input() calendar!: SeasonCalendar;
  @Input() selectedSeason!: VacationsSeason;
  @Input() notSelectedSeason!: VacationsSeason;
  @Input() initialSlots: IProposal[] = [];
  @Input() hiddenSlots!: IProposal[];
  @Input() emptySlots!: ErrorMsg;

  @Output() slotClicked = new EventEmitter<IProposal[]>();

  readonly isMomoUser = false;
  selectedSlots: IProposal[] = [];
  selectedSlots$: BehaviorSubject<IProposal[]> = new BehaviorSubject<IProposal[]>([]);

  constructor(private alertService: AlertService, private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initialSlots) {
      if (!isEqual(changes.initialSlots.previousValue, changes.initialSlots.currentValue)) {
        this.selectedSlots = [];
        this.initialSlots.forEach((slot) => this.selectSlot(slot));
      } else {
        this.selectedSlots = this.initialSlots;
      }
    }
  }

  selectSlot(slot: IProposal) {
    const slotIndex = this.selectedSlots.findIndex(
      (storedSlot) => storedSlot.start_date === slot.start_date && storedSlot.end_date === slot.end_date
    );

    if (this.isSelectedSlot(slot) !== -1) {
      this.selectedSlots.splice(slotIndex, 1);
    } else if (countDays(this.selectedSlots) + slot.num_of_days! > this.calendar.maxHolidays) {
      this.showWarningToast('MANAGE_VACATIONS.MAX_HOLIDAYS_REACHED');
    } else {
      this.selectedSlots.push(slot);
    }

    this.selectedSlots$.next(this.selectedSlots);
    this.slotClicked.emit(this.selectedSlots);
  }

  isSelectedSlot(slot: IProposal) {
    return this.selectedSlots.findIndex(
      (storedSlot) => storedSlot.start_date === slot.start_date && storedSlot.end_date === slot.end_date
    );
  }

  trackByItems(item: MSafeAny) {
    return item;
  }

  private showWarningToast(msg: string) {
    this.alertService.showWarning(
      this.translateService.instant('ERRORS_TOASTS.GENERIC_MSG'),
      this.translateService.instant(msg)
    );
  }
}
